module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptertitle"
  }, [_vm._v("Daria Schooler's Altered States Pancakes")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("\"My passion for motorcycling started after I lost 100 pounds and was able to start wearing leather. That landed me at the local Harley dealer quite a bit. It wasn't long before I started sitting on bikes and chose the Fat Boy. It got a new paint job, pipes, engine guard, and "), _c('em', [_vm._v("lots")]), _vm._v(" of chrome, including a tank cover with a Dreamcatcher engraved on it. The same design is etched into the windshield and is the bike's name on the plate frame. This bike was just the beginning. Now I have a 2001 Sportster 1200 and a 2002 red Screamin' Eagle Road King for short- and long-distance riding respectively. Nothing is more liberating to the soul than rolling down the road on a Harley. The sound of the machine, the wind, the smells in the air, and the feel of the bike rumbling on the pavement, taking you where you may never have been before, make every journey in life worthwhile. But all that riding makes one very hungry! Just recently I discovered my passion for cooking equals my passion for riding. In fact, I discovered both at about the same time, after turning forty! It's true, old dogs can definitely learn new tricks. My love for life is forever joined with my love for learning.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('a', {
    attrs: {
      "id": "p8"
    }
  }), _vm._v(" \"My mom makes great pancakes and I asked her to share her recipe with me. To add variety and a flavor other than syrup to pancakes, I changed a few ingredients around from her basic recipe to liven things up. As with my Dreamcatcher, switching the paint and adding lots of special chrome to create a unique and beautiful bike, altering Mom's basic recipe has led to some awesome results. Basically, substitution of different ingredients for some or all of the milk quantity is the secret to custom Altered States Pancakes. Every pancake chef can come up with their own.\"")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1¾")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cups all-purpose flour")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("tablespoon baking powder")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("¼")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("teaspoon salt")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("teaspoons sugar")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("large eggs, separated (whip the egg whites until stiff peaks form)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1¾")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cups milk (see "), _c('a', {
    attrs: {
      "href": "#/c007#p9"
    }
  }, [_vm._v("[>]")]), _vm._v(" for variations)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("½")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("teaspoon vanilla extract")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("⅓")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup vegetable oil")])])])]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("In a large mixing bowl combine the dry ingredients. Add the egg yolks, milk, vanilla, and oil and beat with an electric mixer until smooth. Add the whipped egg whites by gently stirring them into the batter with a rubber spatula.")]), _vm._v(" "), _c('li', [_vm._v("Ladle the pancake batter into a hot greased skillet over medium heat. Flip over when bubbles start to form on top. Remove from the pan when both sides are golden brown.")]), _vm._v(" "), _c('li', [_vm._v("Top with butter or whatever you like and enjoy!")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("MAKES")]), _vm._v(" 15 "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("PANCAKES")])])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ALTERED STATES #1")])]), _vm._v(" For banana walnut pancakes, substitute for the milk 1 banana, peeled and liquefied in a blender, ½ cup black walnut liqueur, and ¾ cup heavy cream.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ALTERED STATES #2")])]), _vm._v(" For blueberry white chocolate pancakes, substitute one 12-ounce can evaporated milk and ¼ cup white chocolate liqueur for the milk and stir ¾ cup fresh blueberries, picked over for stems, into the batter.")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('img', {
    staticClass: "art",
    attrs: {
      "alt": "[Image]",
      "id": "fig_BikerBillysHogWildOnAHarleyCookbook_034_1",
      "src": "images/BikerBillysHogWildOnAHarleyCookbook_034_1.jpg",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_c('em', [_vm._v("Daria Schooler and her custom Fat Boy")])])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26644936","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c006.vue
// module id = 96
// module chunks = 0